<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="600px"
    :show-close="true"
    title="选择收款账号"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <div class="lists">
      <div v-for="(item, $i) in bankList" :key="item.id" class="panle" @click="changeSelect(item, $i)">
        <div class="left">
          <svg-icon className="icon" :iconClass="item.iconClass" />
          <div class="content">
            <p class="bank-name">
              {{ item.bankName }}
              <span :class="item.currency.toUpperCase()">{{
                item.currency.toUpperCase()
              }}</span>
            </p>
            <p class="bank-name">{{ item.bankBranchName }}</p>
            <p class="bank-number">{{ item.accountNumber }}</p>
            <p class="address">{{ item.accountName }}</p>
          </div>
        </div>
        <div class="right">
          <el-checkbox
            v-model="item.isCheck"
            @change="changeSelect(item, $i)"
          ></el-checkbox>
        </div>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok">完成</div>
    </span>
  </el-dialog>
</template>

<script>
import { supplierBanckAccount } from '@/api/system'
import { companyBankAccount } from '@/api/fee'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    companyId: {
        type: String,
        default: ''
    },
    supplierId: {
        type: String,
        default: ''
    },
    typeActive: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      value: {}
    }
  },
  computed: {
    bankList() {
      const arr = this.list.map((item) => {
        let iconClass = ''
        switch (item.swiftCode) {
          case 'ABOCCNBJ':
            iconClass = 'nyyh'
            break
          case 'BKCHCNBJ':
            iconClass = 'zgyh'
            break
          case 'CIBKCNBJ':
            iconClass = 'zxyh'
            break
          case 'CMBCCNBS':
            iconClass = 'zsyh'
            break
          case 'COMMCN':
            iconClass = 'jtyh'
            break
          case 'HSBCCN':
            iconClass = 'hfyh'
            break
          case 'ICBKCNBJ':
            iconClass = 'gsyh'
            break
          case 'PCBCCNBJ':
            iconClass = 'jsyh'
            break
          case 'CITIHKAX':
            iconClass = 'hqyh'
            break
          case 'PCBCCNBJXXX':
            iconClass = 'mgyh'
            break
        }
        return {
          ...item,
          iconClass
        }
      })
      return arr
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        if (!this.typeActive) {
          this.getAccountList()
        } else {
          this.getBanckAccount()
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    async getAccountList() {
      const res = await companyBankAccount({
        companyId: this.companyId
      })
      if (res.success) {
        this.list = res.data.map(item => {
          return {
            ...item,
          isCheck: false
          }
        })
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async getBanckAccount() {
      const res = await supplierBanckAccount({
        supplierId: this.supplierId
      })
      if (res.success) {
        this.list = res.data
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    changeSelect(item) {
      const list = JSON.parse(JSON.stringify(this.bankList))
      list.forEach(a => {
        if (a.id === item.id) {
          a.isCheck = !a.isCheck
        } else {
          a.isCheck = false
        }
      })
      this.list = list
      // for (const i in this.value) {
      //   this.value[i] = false
      // }
      // this.value[key] = true
    },
    cancel() {
      this.$emit('cancel')
    },
    ok() {
      const item = this.bankList.find((a) => a.isCheck)
      if (!item) {
        this.$message.warning('未选择账号')
        return
      }
      this.$emit('ok', item)
    }
  }
}
</script>

<style lang="less" scoped>
.lists {
  width: 100%;
  height: 390px;
  overflow-y: auto;
  .panle {
    width: calc(100% - 32px);
    height: 90px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    padding: 16px;
    justify-content: space-between;
    display: flex;
    cursor: pointer;
    & + .panle {
      margin-top: 8px;
    }
  }
  .left {
    display: flex;
  }
  .bank-name {
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #7c8db5;
    line-height: 16px;
  }
  .bank-number {
    margin-top: 8px;
    height: 26px;
    font-size: 20px;
    font-weight: 400;
    color: #25396f;
    line-height: 26px;
  }
  .address {
    margin-top: 8px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #7c8db5;
    line-height: 24px;
  }
  .RMB {
    width: 27px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #fe453d;
    line-height: 16px;
    padding: 2px 4px;
    background: rgba(254, 69, 61, 0.1);
    border-radius: 4px 4px 4px 4px;
    margin-left: 10px;
  }
  .USD {
    width: 27px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #35ba83;
    line-height: 16px;
    padding: 2px 4px;
    background: rgba(53, 186, 131, 0.1);
    border-radius: 4px 4px 4px 4px;
    margin-left: 10px;
  }
  .icon {
    font-size: 32px;
    margin-right: 8px;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #f2f7ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dbe4f2;
    color: #7c8db5;
    margin-right: 16px;
    box-sizing: border-box;
  }
  .ok {
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    color: #ffffff;
  }
}
</style>
